const utils = {

    ecuHistoryFixer: (rows) => {
        var temp = rows.reverse()
        var first_id = 0
        var prev_calib_id = 0
        temp.map(row => {
            if (row._TBL === "calib") {
                //console.log(row.calib_id)
                if (first_id === 0) {
                    first_id = row.calib_id
                }
                row.first_calib_id = first_id
                if (prev_calib_id !== row.calib_id) {
                    row.prev_calib_id = prev_calib_id
                    prev_calib_id = row.calib_id
                } else {
                    row.prev_calib_id = 0
                }
            }
        })
        //console.log(temp)
        return temp.reverse()
    },

    sleep: (ms) => {
        return new Promise(resolve => setTimeout(resolve, ms));
    },

    /**
     * Verifica se l'utente possiede un determinato ruolo.
     *
     * La funzione valuta il campo "role" dell'utente nel seguente modo:
     * - Se l'utente non esiste o il campo "role" è assente, restituisce false.
     * - Il campo "role" può essere una stringa contenente ruoli separati da virgola oppure un array di stringhe.
     * - Per ciascun ruolo, viene eliminato il prefisso "ROLE_" (se presente) per normalizzare i ruoli.
     * - Il parametro targetRole viene anch'esso normalizzato rimuovendo eventuale prefisso "ROLE_".
     * - Se il targetRole è "ADMIN", la funzione ritorna true solo se anche "user.is_admin" è true.
     * - In altri casi, se l'utente è amministratore (user.is_admin === true) e possiede il ruolo "ADMIN",
     *   viene comunque restituito true, indipendentemente dal targetRole richiesto.
     * - Altrimenti, viene verificato se il ruolo normalizzato target è presente nell'array dei ruoli normalizzati dell'utente.
     *
     * @param {Object} user - L'oggetto utente, che deve avere almeno un campo "role" (stringa separata da virgole o array di stringhe)
     *                        e, eventualmente, un campo "is_admin" booleano.
     * @param {string} targetRole - Il ruolo da verificare. Può essere specificato con o senza il prefisso "ROLE_".
     *                              Se il targetRole è "ADMIN", viene considerato valido solo se user.is_admin === true.
     * @returns {boolean} Ritorna true se l'utente possiede il ruolo target (secondo le regole descritte), altrimenti false.
     */
    userHasRole: (user, targetRole) => {
        if (!user || !user.role) return false;
        // Esegui il trim su targetRole
        const trimmedTarget = targetRole.trim();
        // Estrai i ruoli dall'utente: se è stringa, assumiamo che siano separati da ,
        const roles = typeof user.role === 'string'
            ? user.role.split(',').map(role => role.trim())
            : Array.isArray(user.role)
                ? user.role
                : [];
        // Normalizza i ruoli dell'utente eliminando "ROLE_" se presente
        const normalizedRoles = roles.map(r => r.startsWith("ROLE_") ? r.substring(5) : r);
        // Normalizza il target: se inizia con "ROLE_" rimuovilo
        const normalizedTarget = trimmedTarget.startsWith("ROLE_") ? trimmedTarget.substring(5) : trimmedTarget;
        if (normalizedTarget === "ADMIN") return user.is_admin === true;        
        // Se l'utente è amministratore e possiede ADMIN, ritorna true
        if (user.is_admin === true && normalizedRoles.includes("ADMIN")) return true;        
        return normalizedRoles.includes(normalizedTarget);
    },
    userHasRoleAdmin: (user) => { return utils.userHasRole(user, "ADMIN") },
    userHasRoleGuest: (user) => {
        // Se l'utente non esiste o il campo role è vuoto, consideriamo l'utente come guest
        if (!user || !user.role || user.role.trim() === "") return true;
        // Estrai i ruoli dall'utente: se è stringa, assumiamo che siano separati da ,
        const roles = typeof user.role === 'string'
            ? user.role.split(',').map(role => role.trim())
            : Array.isArray(user.role)
                ? user.role
                : [];
        // Normalizza i ruoli dell'utente eliminando "ROLE_" se presente
        const normalizedRoles = roles.map(r => r.startsWith("ROLE_") ? r.substring(5) : r);
        // Normalizza il target: se inizia con "ROLE_" rimuovilo
        const normalizedTarget = "GUEST";
        return normalizedRoles.includes(normalizedTarget);
    },

}

export default utils;
